import { ReactNode } from 'react';

import { cn, dynamicStyling, resolveColor } from 'styles';

import { IconProps } from './types';

interface SVGWrapProps extends IconProps {
  children: ReactNode;

  /**
   * Defaults to `stroke`
   */
  colorTarget?: 'stroke' | 'fill';
}

export function SVG({
  size = 18,
  className,
  children,
  color = 'currentColor',
  colorTarget = 'stroke',
}: SVGWrapProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={colorTarget === 'fill' ? resolveColor(color) : 'none'}
      stroke={colorTarget === 'stroke' ? resolveColor(color) : 'none'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...dynamicStyling({
        size,

        className: cn('shrink-0 text-inherit', className),
      })}
    >
      {children}
    </svg>
  );
}
